<template>
  <div>
    <BreadCrumb PageTitle="Wholesale Order Details" :IntermediaryItems="breadcrumbItems" />
    <MerchantOrderDetails />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import MerchantOrderDetails from "../../components/Wholesale/MerchantOrderDetails.vue";

export default defineComponent({
  name: "MerchantOrderDetailsPage",
  components: {
    BreadCrumb,
    MerchantOrderDetails,
  },
  data() {
    return {
      breadcrumbItems: [
        {
          name: 'Wholesale Orders List',
          to: '/wholesale/orders'
        }
      ]
    }
  }
});
</script>